<template>
  <!-- the year's sidebar beside it, as on the year's page, its Highlights the Masterclass
       talks as "Talks" (useYearPageSidebar.js, sidebar.json PAGES; Seán, 2026-10-28). On a
       narrow screen the Program is a panel of the sidebar too (Seán, 2026-10-28) -->
  <ReplaceTweets v-if="$route.name" :is-single-column="isSingleColumn">
    <YearSidebar
      v-if="sidebar && isNarrow"
      :content="narrowSidebar"
      :year="year"
      title="Masterclass"
      is-narrow>
      <template #program><MasterclassTables :heading="false" /></template>
    </YearSidebar>
    <h3 v-else>Masterclass</h3>
    <div v-show="!isPanelShown" :class="{isBelowControl: sidebar && isNarrow}">
      <!-- v-if prevents errors when switching routes -->
      <component :is="page" v-if="$route.name" />
      <MasterclassTables v-if="!isNarrow" />
    </div>
    <template v-if="sidebar && !isNarrow" #right>
      <YearSidebar :content="sidebar" :year="year" title="Masterclass" />
    </template>
  </ReplaceTweets>
</template>

<script setup>
import {nextTick, shallowRef, watch} from "vue";
import {useRoute} from "vue-router";
import MasterclassTables from "@/components/Program/MasterclassTables.vue";
import ReplaceTweets from "@/components/ReplaceTweets.vue";
import YearSidebar from "@/components/YearSidebar/YearSidebar.vue";
import {getPageSidebar, useYearPageSidebar} from "@/composables/useYearPageSidebar";
const route = useRoute();
const year = String(route.params.year || "");
// the year's sidebar content, or null (most years have none)
function getSidebar() {
  try {
    return year ? require(`@/assets/years/${year}/sidebar.json`) : null;
  } catch {
    return null;
  }
}
const {sidebar, narrowSidebar, isNarrow, isPanelShown, isSingleColumn} = useYearPageSidebar(
  getPageSidebar(getSidebar(), "masterclass"));
let page = shallowRef();
try {
  if (year) {
    page = shallowRef(require(`@/assets/years/${year}/Masterclass/Index.vue`).default);
  }
} catch (error) {
  console.error(`Masterclass.vue|${year} error: ${error}`);
}
// #program, the Program's own address (links elsewhere on the site; Seán, 2026-10-28): on a wide
// screen the heading on the page, scrolled to once the page has rendered; on a narrow one the
// sidebar's panel (YearSidebar.vue). Again when the screen widens with the hash still there
function scrollToProgram() {
  document.getElementById("program")?.scrollIntoView({behavior: "smooth", block: "start"});
}
watch(() => [route.hash, isNarrow.value], async ([hash, narrow]) => {
  if (hash !== "#program" || narrow) return;
  await nextTick();
  setTimeout(scrollToProgram, 350);
}, {immediate: true});
</script>

<style scoped>
.isBelowControl {
  padding-top: 18px;
}
</style>
